const en = {
  common: {
    or: 'or',
    cancel: 'Cancel',
    reset: 'Reset',
    save: 'Save',
    search: 'Search',
    edit: 'Edit',
    new: 'New',
    export: 'Export to Excel',
    noDataToExport: 'No data to export',
    import: 'Import',
    discard: 'Discard',
    yes: 'Yes',
    no: 'No',
    pause: 'Pause',
    areYouSure: 'Are you sure?',
    view: 'View',
    destroy: 'Delete',
    mustSelectARow: 'Must select a row',
    start: 'Start',
    end: 'End',
    select: 'Select',
    continue: 'Continue',
    filters: 'Filters',
    backToSignIn: 'Back To Sign In',
  },

  app: {
    title: 'Open X',
  },

  api: {
    menu: 'API',
  },

  entities: {
    skill: {
      name: 'skill',
      label: 'Skills',
      menu: 'Skills',
      exporterFileName: 'skill_export',
      list: {
        menu: 'Skills',
        title: 'Skills',
      },
      create: {
        success: 'Skill successfully saved',
      },
      update: {
        success: 'Skill successfully saved',
      },
      destroy: {
        success: 'Skill successfully deleted',
      },
      destroyAll: {
        success: 'Skill(s) successfully deleted',
      },
      edit: {
        title: 'Edit Skill',
      },
      fields: {
        id: 'Id',
        'title': 'Title',
        'relatedSkills': 'Related Skills',
        'description': 'Description',
        'coverImage': 'Cover Image',
        'courses': 'Courses',
        'tags': 'Tags',
        'manuals': 'Manuals',
        'companyTag': 'CompanyTag',
        'threeDModels': 'ThreeDModels',
        'enableSkillAI': 'Enable AI',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Skill',
      },
      view: {
        title: 'View Skill',
      },
      importer: {
        title: 'Import Skills',
        fileName: 'skill_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    path: {
      name: 'path',
      label: 'Paths',
      menu: 'Paths',
      exporterFileName: 'path_export',
      list: {
        menu: 'Paths',
        title: 'Paths',
      },
      create: {
        success: 'Path successfully saved',
      },
      update: {
        success: 'Path successfully saved',
      },
      destroy: {
        success: 'Path successfully deleted',
      },
      destroyAll: {
        success: 'Path(s) successfully deleted',
      },
      edit: {
        title: 'Edit Path',
      },
      fields: {
        id: 'Id',
        'title': 'Title',
        'description': 'Description',
        'category': 'Category',
        'skills': 'Skills',
        'courses': 'Courses',
        'nodes': 'Nodes',
        'edges': 'Edges',
        'skill': 'Skill',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {
        'category': {
          'robotics': 'Robotics',
          'programming': 'Programming',
          '3dmodeling': '3d modeling',
          'reverse_engineering': 'Reverse_engineering',
        },
      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Path',
      },
      view: {
        title: 'Path',
      },
      importer: {
        title: 'Import Paths',
        fileName: 'path_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    pathProgress: {
      name: 'pathProgress',
      label: 'Path Progresses',
      menu: 'Path Progresses',
      exporterFileName: 'pathProgress_export',
      list: {
        menu: 'Path  Progresses',
        title: 'Path Progresses',
      },
      create: {
        success: 'Path Progress successfully saved',
      },
      update: {
        success: 'Path Progress successfully saved',
      },
      destroy: {
        success: 'Path Progress successfully deleted',
      },
      destroyAll: {
        success: 'Path Progress(s) successfully deleted',
      },
      edit: {
        title: 'Edit Path Progress',
      },
      fields: {
        id: 'Id',
        'path': 'Path',
        'coursesInPath': 'Courses In Path',
        'inProgress': 'In Progress Courses',
        'completed': 'Completed Courses',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Path Progress',
      },
      view: {
        title: 'View Path Progress',
      },
      importer: {
        title: 'Import Path Progresses',
        fileName: 'pathProgress_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    course: {
      name: 'course',
      label: 'Courses',
      menu: 'Courses',
      exporterFileName: 'course_export',
      list: {
        menu: 'Courses',
        title: 'Courses',
      },
      create: {
        success: 'Course successfully saved',
      },
      update: {
        success: 'Course successfully saved',
      },
      destroy: {
        success: 'Course successfully deleted',
      },
      destroyAll: {
        success: 'Course(s) successfully deleted',
      },
      edit: {
        title: 'Course Details',
      },
      fields: {
        id: 'Id',
        'title': 'Title',
        'description': 'Description',
        'thumbnail': 'Thumbnail',
        'sections': 'Sections',
        'users': 'Users',
        'trailer': 'Trailer',
        'categories': 'Categories',
        'totalLessonsRange': 'TotalLessons',
        'totalLessons': 'TotalLessons',
        'projects': 'Projects',
        'skills': 'Skills',
        'teaser': 'Teaser',
        'bannerImage': 'BannerImage',
        'bannerVideo': 'BannerVideo',
        'viewCategories': 'View Categories',
        'courseWingman': 'CourseWingman',
        'overviewSettings': 'OverviewSettings',
        'aIResourceBucket': 'AIResourceBucket',
        'trainingDataText': 'Data String AI Is Trained On',
        'zIndexRange': 'ZIndex',
        'zIndex': 'ZIndex',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {
        'viewCategories': {
          'featured': 'Featured',
          'banner': 'Banner',
          'hover_teaser': 'Hover_teaser',
          'dod_only': 'Dod_only',
          'single_lesson': 'Single_Lesson',
          'fundamental': 'Fundamental',
          'intermediate': 'Intermediate',
          'advanced': 'Advanced',
        },
      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Course',
      },
      view: {
        title: 'Course',
      },
      importer: {
        title: 'Import Courses',
        fileName: 'course_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    lesson: {
      name: 'lesson',
      label: 'Lessons',
      menu: 'Lessons',
      exporterFileName: 'lesson_export',
      list: {
        menu: 'Lessons',
        title: 'Lessons',
      },
      create: {
        success: 'Lesson successfully saved',
      },
      update: {
        success: 'Lesson successfully saved',
      },
      destroy: {
        success: 'Lesson successfully deleted',
      },
      destroyAll: {
        success: 'Lesson(s) successfully deleted',
      },
      edit: {
        title: 'Edit Lesson',
      },
      fields: {
        id: 'Id',
        'video': 'Video',
        'title': 'Title',
        'description': 'Description',
        'transcript': 'Transcript',
        'thumbnail': 'Thumbnail',
        'content': 'Content',
        'quiz': 'Quiz',
        'wingmanTrained': 'Wingman Trained',
        'skills': 'Skills',
        'trainingDataText': 'Data Used To Train The Lesson AI On',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
        pdf: 'PDF'
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Lesson',
      },
      view: {
        title: 'Lesson',
      },
      importer: {
        title: 'Import Lessons',
        fileName: 'lesson_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    section: {
      name: 'section',
      label: 'Sections',
      menu: 'Sections',
      exporterFileName: 'section_export',
      list: {
        menu: 'Sections',
        title: 'Sections',
      },
      create: {
        success: 'Section successfully saved',
      },
      update: {
        success: 'Section successfully saved',
      },
      destroy: {
        success: 'Section successfully deleted',
      },
      destroyAll: {
        success: 'Section(s) successfully deleted',
      },
      edit: {
        title: 'Edit Section',
      },
      fields: {
        id: 'Id',
        'lessons': 'Lessons',
        'test': 'Test',
        'title': 'Title',
        'sectionAITrainingText': 'Data for AI Training of Section',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Section',
      },
      view: {
        title: 'Section',
      },
      importer: {
        title: 'Import Sections',
        fileName: 'section_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    question: {
      name: 'question',
      label: 'Questions',
      menu: 'Questions',
      exporterFileName: 'question_export',
      list: {
        menu: 'Questions',
        title: 'Questions',
      },
      create: {
        success: 'Question successfully saved',
      },
      update: {
        success: 'Question successfully saved',
      },
      destroy: {
        success: 'Question successfully deleted',
      },
      destroyAll: {
        success: 'Question(s) successfully deleted',
      },
      edit: {
        title: 'Edit Question',
      },
      fields: {
        id: 'Id',
        'question': 'Question',
        'answer': 'Answer',
        'gradeRange': 'Grade',
        'grade': 'Grade',
        'nextReviewDateRange': 'NextReviewDate',
        'nextReviewDate': 'NextReviewDate',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
        skill: 'Skill',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Question',
      },
      view: {
        title: 'Question',
      },
      importer: {
        title: 'Import Questions',
        fileName: 'question_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    test: {
      name: 'test',
      label: 'Tests',
      menu: 'Tests',
      exporterFileName: 'test_export',
      list: {
        menu: 'Tests',
        title: 'Tests',
      },
      create: {
        success: 'Test successfully saved',
      },
      update: {
        success: 'Test successfully saved',
      },
      destroy: {
        success: 'Test successfully deleted',
      },
      destroyAll: {
        success: 'Test(s) successfully deleted',
      },
      edit: {
        title: 'Edit Test',
      },
      fields: {
        id: 'Id',
        'questions': 'Questions',
        'title': 'Title',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Test',
      },
      view: {
        title: 'Test',
      },
      importer: {
        title: 'Import Tests',
        fileName: 'test_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    quiz: {
      name: 'quiz',
      label: 'Quizes',
      menu: 'Quizes',
      exporterFileName: 'quiz_export',
      list: {
        menu: 'Quizes',
        title: 'Quizes',
      },
      create: {
        success: 'Quiz successfully saved',
      },
      update: {
        success: 'Quiz successfully saved',
      },
      destroy: {
        success: 'Quiz successfully deleted',
      },
      destroyAll: {
        success: 'Quiz(s) successfully deleted',
      },
      edit: {
        title: 'Edit Quiz',
      },
      fields: {
        id: 'Id',
        'questions': 'Questions',
        'title': 'Title',
        'skill': 'Skill',
        'thumbnail': 'Thumbnail',
        'description': 'Description',
        'shortDescription': 'ShortDescription',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Quiz',
      },
      view: {
        title: 'View Quiz',
      },
      importer: {
        title: 'Import Quizes',
        fileName: 'quiz_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    userData: {
      name: 'userData',
      label: 'UserData',
      menu: 'UserData',
      exporterFileName: 'userData_export',
      list: {
        menu: 'UserData',
        title: 'UserData',
      },
      create: {
        success: 'UserData successfully saved',
      },
      update: {
        success: 'UserData successfully saved',
      },
      destroy: {
        success: 'UserData successfully deleted',
      },
      destroyAll: {
        success: 'UserData(s) successfully deleted',
      },
      edit: {
        title: 'Edit UserData',
      },
      fields: {
        id: 'Id',
        'courses': 'Courses',
        'user': 'User',
        'skills': 'Skills',
        'coursesProgress': 'Courses Progress',
        'skillProfiles': 'Skill Profiles',
        'projectProgresses': 'Project Progresses',
        'resume': 'Resume',
        'pathProgresses': 'Path Progresses',
        'jobApplications': 'JobApplications',
        'jobNotifications': 'JobNotifications',
        'careerProfile': 'CareerProfile',
        'skillAssesmentProfiles': 'Skill Profiles',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New UserData',
      },
      view: {
        title: 'View UserData',
      },
      importer: {
        title: 'Import UserData',
        fileName: 'userData_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    ResumeCapture: {
      name: 'ResumeCapture',
      label: 'ResumeCaptures',
      menu: 'ResumeCaptures',
      exporterFileName: 'ResumeCapture_export',
      list: {
        menu: 'ResumeCaptures',
        title: 'ResumeCaptures',
      },
      create: {
        success: 'ResumeCapture successfully saved',
      },
      update: {
        success: 'ResumeCapture successfully saved',
      },
      destroy: {
        success: 'ResumeCapture successfully deleted',
      },
      destroyAll: {
        success: 'ResumeCapture(s) successfully deleted',
      },
      edit: {
        title: 'Edit ResumeCapture',
      },
      fields: {
        id: 'Id',
        'firstName': 'FirstName',
        'lastName': 'LastName',
        'email': 'Email',
        'phoneNumber': 'PhoneNumber',
        'currentCareerAndDesiredPosition': 'CurrentCareerAndDesiredPosition',
        'currentJobTitle': 'CurrentJobTitle',
        'experienceYearsRange': 'Years of Experience ',
        'experienceYears': 'Years of Experience ',
        'interestedInCareer': 'InterestedInCareer',
        'resume': 'Resume',
        'referrer': 'Referrer',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New ResumeCapture',
      },
      view: {
        title: 'View ResumeCapture',
      },
      importer: {
        title: 'Import ResumeCaptures',
        fileName: 'ResumeCapture_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },


    category: {
      name: 'category',
      label: 'Categories',
      menu: 'Categories',
      exporterFileName: 'category_export',
      list: {
        menu: 'Categories',
        title: 'Categories',
      },
      create: {
        success: 'Category successfully saved',
      },
      update: {
        success: 'Category successfully saved',
      },
      destroy: {
        success: 'Category successfully deleted',
      },
      destroyAll: {
        success: 'Category(s) successfully deleted',
      },
      edit: {
        title: 'Edit Category',
      },
      fields: {
        id: 'Id',
        'label': 'Label',
        'course': 'Course',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Category',
      },
      view: {
        title: 'Category',
      },
      importer: {
        title: 'Import Categories',
        fileName: 'category_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    courseProgress: {
      name: 'courseProgress',
      label: 'CourseProgresses',
      menu: 'CourseProgresses',
      exporterFileName: 'courseProgress_export',
      list: {
        menu: 'CourseProgresses',
        title: 'CourseProgresses',
      },
      create: {
        success: 'CourseProgress successfully saved',
      },
      update: {
        success: 'CourseProgress successfully saved',
      },
      destroy: {
        success: 'CourseProgress successfully deleted',
      },
      destroyAll: {
        success: 'CourseProgress(s) successfully deleted',
      },
      edit: {
        title: 'Edit CourseProgress',
      },
      fields: {
        id: 'Id',
        'course': 'Course',
        'currentLesson': 'CurrentLesson',
        'completedLessons': 'CompletedLessons',
        'grades': 'Grades',
        'progressRange': 'Progress',
        'progress': 'Progress',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New CourseProgress',
      },
      view: {
        title: 'CourseProgress',
      },
      importer: {
        title: 'Import CourseProgresses',
        fileName: 'courseProgress_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    skillProfile: {
      name: 'skillProfile',
      label: 'SkillProfiles',
      menu: 'SkillProfiles',
      exporterFileName: 'skillProfile_export',
      list: {
        menu: 'SkillProfiles',
        title: 'SkillProfiles',
      },
      create: {
        success: 'SkillProfile successfully saved',
      },
      update: {
        success: 'SkillProfile successfully saved',
      },
      destroy: {
        success: 'SkillProfile successfully deleted',
      },
      destroyAll: {
        success: 'SkillProfile(s) successfully deleted',
      },
      edit: {
        title: 'Edit SkillProfile',
      },
      fields: {
        id: 'Id',
        'questions': 'Questions',
        'pointsRange': 'Points',
        'points': 'Points',
        'skill': 'Skill',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New SkillProfile',
      },
      view: {
        title: 'SkillProfile',
      },
      importer: {
        title: 'Import SkillProfiles',
        fileName: 'skillProfile_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    project: {
      name: 'project',
      label: 'Projects',
      menu: 'Projects',
      exporterFileName: 'project_export',
      list: {
        menu: 'Projects',
        title: 'Projects',
      },
      create: {
        success: 'Project successfully saved',
      },
      update: {
        success: 'Project successfully saved',
      },
      destroy: {
        success: 'Project successfully deleted',
      },
      destroyAll: {
        success: 'Project(s) successfully deleted',
      },
      edit: {
        title: 'Edit Project',
      },
      fields: {
        id: 'Id',
        'description': 'Description',
        'thumbnail': 'Thumbnail',
        'skills': 'Skills',
        'votesRange': 'Votes',
        'votes': 'Votes',
        'title': 'Title',
        'content': 'Content',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Project',
      },
      view: {
        title: 'Project',
      },
      importer: {
        title: 'Import Projects',
        fileName: 'project_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    projectContent: {
      name: 'projectContent',
      label: 'ProjectContents',
      menu: 'ProjectContents',
      exporterFileName: 'projectContent_export',
      list: {
        menu: 'ProjectContents',
        title: 'ProjectContents',
      },
      create: {
        success: 'ProjectContent successfully saved',
      },
      update: {
        success: 'ProjectContent successfully saved',
      },
      destroy: {
        success: 'ProjectContent successfully deleted',
      },
      destroyAll: {
        success: 'ProjectContent(s) successfully deleted',
      },
      edit: {
        title: 'Edit ProjectContent',
      },
      fields: {
        id: 'Id',
        'indexRange': 'Index',
        'index': 'Index',
        'text': 'Text',
        'video': 'Video',
        'pdf': 'Pdf',
        'images': 'Images',
        'zip': 'Zip',
        'title': 'Title',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New ProjectContent',
      },
      view: {
        title: 'ProjectContent',
      },
      importer: {
        title: 'Import ProjectContents',
        fileName: 'projectContent_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    projectSubmittedContent: {
      name: 'projectSubmittedContent',
      label: 'ProjectSubmittedContents',
      menu: 'ProjectSubmittedContents',
      exporterFileName: 'projectSubmittedContent_export',
      list: {
        menu: 'ProjectSubmittedContents',
        title: 'ProjectSubmittedContents',
      },
      create: {
        success: 'ProjectSubmittedContent successfully saved',
      },
      update: {
        success: 'ProjectSubmittedContent successfully saved',
      },
      destroy: {
        success: 'ProjectSubmittedContent successfully deleted',
      },
      destroyAll: {
        success: 'ProjectSubmittedContent(s) successfully deleted',
      },
      edit: {
        title: 'Edit ProjectSubmittedContent',
      },
      fields: {
        id: 'Id',
        'text': 'Text',
        'images': 'Image',
        'video': 'Video',
        'pdf': 'Pdf',
        'zip': 'Zip',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New ProjectSubmittedContent',
      },
      view: {
        title: 'ProjectSubmittedContent',
      },
      importer: {
        title: 'Import ProjectSubmittedContents',
        fileName: 'projectSubmittedContent_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    projectProgress: {
      name: 'projectProgress',
      label: 'ProjectProgresses',
      menu: 'ProjectProgresses',
      exporterFileName: 'projectProgress_export',
      list: {
        menu: 'ProjectProgresses',
        title: 'ProjectProgresses',
      },
      create: {
        success: 'ProjectProgress successfully saved',
      },
      update: {
        success: 'ProjectProgress successfully saved',
      },
      destroy: {
        success: 'ProjectProgress successfully deleted',
      },
      destroyAll: {
        success: 'ProjectProgress(s) successfully deleted',
      },
      edit: {
        title: 'Edit ProjectProgress',
      },
      fields: {
        id: 'Id',
        'project': 'Project',
        'submittedContent': 'SubmittedContent',
        'certified': 'Certified',
        'gradeRange': 'Grade',
        'grade': 'Grade',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New ProjectProgress',
      },
      view: {
        title: 'ProjectProgress',
      },
      importer: {
        title: 'Import ProjectProgresses',
        fileName: 'projectProgress_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    jobListing: {
      name: 'Job',
      label: 'Jobs',
      menu: 'Jobs',
      exporterFileName: 'Job_export',
      list: {
        menu: 'Jobs',
        title: 'Jobs',
      },
      create: {
        success: 'Job successfully saved',
      },
      update: {
        success: 'Job successfully saved',
      },
      destroy: {
        success: 'Job successfully deleted',
      },
      destroyAll: {
        success: 'Job(s) successfully deleted',
      },
      edit: {
        title: 'Edit Job',
      },
      fields: {
        id: 'Id',
        'position': 'Position',
        'description': 'Description',
        'skills': 'Skills',
        'longitudeRange': 'Longitude',
        'longitude': 'Longitude',
        'latitudeRange': 'Latitude',
        'latitude': 'Latitude',
        'company': 'Company',
        'salaryRange': 'Salary',
        'salary': 'Salary',
        'verified': 'Verified',
        'location': 'Location',
        'logo': 'Logo',
        'employmentType': 'EmploymentType',
        'seniorityLevel': 'Seniority Level',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {
        'employmentType': {
          'full_time': 'Full Time',
          'part_time': 'Part Time',
          'remote': 'Remote',
          'Internship': 'Internship',
          'contract': 'Contract',
        },
        'seniorityLevel': {
          'student_level': 'Student level',
          'entry_level': 'Entry level',
          'mid_level': 'Mid level',
          'senior_level': 'Senior level',
          'director': 'Director Level',
          'vp_or_above': 'Vp or above',
        },
      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Job',
      },
      view: {
        title: 'Job',
      },
      importer: {
        title: 'Import Jobs',
        fileName: 'Job_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    resume: {
      name: 'resume',
      label: 'Resumes',
      menu: 'Resumes',
      exporterFileName: 'resume_export',
      list: {
        menu: 'Resumes',
        title: 'Resumes',
      },
      create: {
        success: 'Resume successfully saved',
      },
      update: {
        success: 'Resume successfully saved',
      },
      destroy: {
        success: 'Resume successfully deleted',
      },
      destroyAll: {
        success: 'Resume(s) successfully deleted',
      },
      edit: {
        title: 'Edit Resume',
      },
      fields: {
        id: 'Id',
        'firstName': 'FirstName',
        'lastName': 'LastName',
        'email': 'Email',
        'phoneNumber': 'PhoneNumber',
        'location': 'Location',
        'personalDescription': 'PersonalDescription',
        'workHistory': 'WorkHistory',
        'education': 'Education',
        'skills': 'Skills',
        'projects': 'Projects',
        'awards': 'Awards',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Resume',
      },
      view: {
        title: 'View Resume',
      },
      importer: {
        title: 'Import Resumes',
        fileName: 'resume_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    userResume: {
      name: 'resume',
      label: 'Resumes',
      menu: 'My Resumes',
      exporterFileName: 'resume_export',
      list: {
        menu: 'My Resumes',
        title: 'My Resumes',
      },
      create: {
        success: 'Resume successfully saved',
      },
      update: {
        success: 'Resume successfully saved',
      },
      destroy: {
        success: 'Resume successfully deleted',
      },
      destroyAll: {
        success: 'Resume(s) successfully deleted',
      },
      edit: {
        title: 'Edit Resume',
      },
      fields: {
        id: 'Id',
        'firstName': 'FirstName',
        'lastName': 'LastName',
        'email': 'Email',
        'phoneNumber': 'PhoneNumber',
        'location': 'Location',
        'personalDescription': 'PersonalDescription',
        'workHistory': 'WorkHistory',
        'education': 'Education',
        'skills': 'Skills',
        'projects': 'Projects',
        'awards': 'Awards',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Resume',
      },
      view: {
        title: 'View Resume',
      },
      importer: {
        title: 'Import Resumes',
        fileName: 'resume_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    workHistory: {
      name: 'workHistory',
      label: 'WorkHistories',
      menu: 'WorkHistories',
      exporterFileName: 'workHistory_export',
      list: {
        menu: 'WorkHistories',
        title: 'WorkHistories',
      },
      create: {
        success: 'WorkHistory successfully saved',
      },
      update: {
        success: 'WorkHistory successfully saved',
      },
      destroy: {
        success: 'WorkHistory successfully deleted',
      },
      destroyAll: {
        success: 'WorkHistory(s) successfully deleted',
      },
      edit: {
        title: 'Edit WorkHistory',
      },
      fields: {
        id: 'Id',
        'company': 'Company',
        'title': 'Title',
        'location': 'Location',
        'startDateRange': 'StartDate',
        'startDate': 'StartDate',
        'endDateRange': 'EndDate',
        'endDate': 'EndDate',
        'description': 'Description',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New WorkHistory',
      },
      view: {
        title: 'View WorkHistory',
      },
      importer: {
        title: 'Import WorkHistories',
        fileName: 'workHistory_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    education: {
      name: 'education',
      label: 'Educations',
      menu: 'Educations',
      exporterFileName: 'education_export',
      list: {
        menu: 'Educations',
        title: 'Educations',
      },
      create: {
        success: 'Education successfully saved',
      },
      update: {
        success: 'Education successfully saved',
      },
      destroy: {
        success: 'Education successfully deleted',
      },
      destroyAll: {
        success: 'Education(s) successfully deleted',
      },
      edit: {
        title: 'Edit Education',
      },
      fields: {
        id: 'Id',
        'school': 'School',
        'degree': 'Degree',
        'startDateRange': 'StartDate',
        'startDate': 'StartDate',
        'endDateRange': 'EndDate',
        'endDate': 'EndDate',
        'location': 'Location',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Education',
      },
      view: {
        title: 'View Education',
      },
      importer: {
        title: 'Import Educations',
        fileName: 'education_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    resumeProject: {
      name: 'resumeProject',
      label: 'ResumeProjects',
      menu: 'ResumeProjects',
      exporterFileName: 'resumeProject_export',
      list: {
        menu: 'ResumeProjects',
        title: 'ResumeProjects',
      },
      create: {
        success: 'ResumeProject successfully saved',
      },
      update: {
        success: 'ResumeProject successfully saved',
      },
      destroy: {
        success: 'ResumeProject successfully deleted',
      },
      destroyAll: {
        success: 'ResumeProject(s) successfully deleted',
      },
      edit: {
        title: 'Edit ResumeProject',
      },
      fields: {
        id: 'Id',
        'title': 'Title',
        'description': 'Description',
        'link': 'Link',
        'openXProject': 'OpenXProject',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New ResumeProject',
      },
      view: {
        title: 'View ResumeProject',
      },
      importer: {
        title: 'Import ResumeProjects',
        fileName: 'resumeProject_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    resumeSkill: {
      name: 'resumeSkill',
      label: 'ResumeSkills',
      menu: 'ResumeSkills',
      exporterFileName: 'resumeSkill_export',
      list: {
        menu: 'ResumeSkills',
        title: 'ResumeSkills',
      },
      create: {
        success: 'ResumeSkill successfully saved',
      },
      update: {
        success: 'ResumeSkill successfully saved',
      },
      destroy: {
        success: 'ResumeSkill successfully deleted',
      },
      destroyAll: {
        success: 'ResumeSkill(s) successfully deleted',
      },
      edit: {
        title: 'Edit ResumeSkill',
      },
      fields: {
        id: 'Id',
        'tag': 'Tag',
        'openXSkill': 'OpenXSkill',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New ResumeSkill',
      },
      view: {
        title: 'View ResumeSkill',
      },
      importer: {
        title: 'Import ResumeSkills',
        fileName: 'resumeSkill_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    awards: {
      name: 'awards',
      label: 'Awards',
      menu: 'Awards',
      exporterFileName: 'awards_export',
      list: {
        menu: 'Awards',
        title: 'Awards',
      },
      create: {
        success: 'Awards successfully saved',
      },
      update: {
        success: 'Awards successfully saved',
      },
      destroy: {
        success: 'Awards successfully deleted',
      },
      destroyAll: {
        success: 'Awards(s) successfully deleted',
      },
      edit: {
        title: 'Edit Awards',
      },
      fields: {
        id: 'Id',
        'title': 'Title',
        'description': 'Description',
        'dateRange': 'Date',
        'date': 'Date',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Awards',
      },
      view: {
        title: 'View Awards',
      },
      importer: {
        title: 'Import Awards',
        fileName: 'awards_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    company: {
      name: 'company',
      label: 'Companies',
      menu: 'Companies',
      exporterFileName: 'company_export',
      list: {
        menu: 'Companies',
        title: 'Companies',
      },
      create: {
        success: 'Company successfully saved',
      },
      update: {
        success: 'Company successfully saved',
      },
      destroy: {
        success: 'Company successfully deleted',
      },
      destroyAll: {
        success: 'Company(s) successfully deleted',
      },
      edit: {
        title: 'Edit Company',
      },
      fields: {
        id: 'Id',
        'name': 'Name',
        'logo': 'Logo',
        'jobs': 'Jobs',
        'description': 'Description',
        'revenueRange': 'Revenue',
        'revenue': 'Revenue',
        'companyLink': 'CompanyLink',
        'avarageSalaryRange': 'AvarageSalary',
        'avarageSalary': 'AvarageSalary',
        'industry': 'Industry',
        'skills': 'Skills',
        'displaySettings': 'DisplaySettings',
        'enableCompanyAI': 'Enable AI',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {
        'industry': {
          'Composites': 'Composites',
        },
      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Company',
      },
      view: {
        title: 'View Company',
      },
      importer: {
        title: 'Import Companies',
        fileName: 'company_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    jobApplication: {
      name: 'jobApplication',
      label: 'Job Applications',
      menu: 'Job Applications',
      exporterFileName: 'jobApplication_export',
      list: {
        menu: 'Job Applications',
        title: 'Job Applications',
      },
      create: {
        success: 'Job Application successfully saved',
      },
      update: {
        success: 'Job Application successfully saved',
      },
      destroy: {
        success: 'Job Application successfully deleted',
      },
      destroyAll: {
        success: 'Job Application(s) successfully deleted',
      },
      edit: {
        title: 'Edit Job Application',
      },
      fields: {
        id: 'Id',
        'job': 'Job',
        'status': 'Status',
        'useData': 'UseData',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {
        'status': {
          'screened': 'Screened',
          'submitted': 'Submitted',
          'interviewing': 'Interviewing',
          'final_interview': 'Final Interview',
          'offer': 'Offer',
          'accepted': 'Accepted',
          'rejected': 'Rejected',
        },
      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New JobApplication',
      },
      view: {
        title: 'View JobApplication',
      },
      importer: {
        title: 'Import JobApplications',
        fileName: 'jobApplication_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    careerProfile: {
      name: 'careerProfile',
      label: 'CareerProfiles',
      menu: 'CareerProfiles',
      exporterFileName: 'careerProfile_export',
      list: {
        menu: 'CareerProfiles',
        title: 'CareerProfiles',
      },
      create: {
        success: 'CareerProfile successfully saved',
      },
      update: {
        success: 'CareerProfile successfully saved',
      },
      destroy: {
        success: 'CareerProfile successfully deleted',
      },
      destroyAll: {
        success: 'CareerProfile(s) successfully deleted',
      },
      edit: {
        title: 'Edit CareerProfile',
      },
      fields: {
        id: 'Id',
        'basic': 'Basic',
        'experience': 'Experience',
        'prefrences': 'Prefrences',
        'generalProfile': 'GeneralProfile',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New CareerProfile',
      },
      view: {
        title: 'View CareerProfile',
      },
      importer: {
        title: 'Import CareerProfiles',
        fileName: 'careerProfile_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    careerProfileBasicDetails: {
      name: 'careerProfileBasicDetails',
      label: 'CareerProfileBasicDetails',
      menu: 'CareerProfileBasicDetails',
      exporterFileName: 'careerProfileBasicDetails_export',
      list: {
        menu: 'CareerProfileBasicDetails',
        title: 'CareerProfileBasicDetails',
      },
      create: {
        success: 'CareerProfileBasicDetails successfully saved',
      },
      update: {
        success: 'CareerProfileBasicDetails successfully saved',
      },
      destroy: {
        success: 'CareerProfileBasicDetails successfully deleted',
      },
      destroyAll: {
        success: 'CareerProfileBasicDetails(s) successfully deleted',
      },
      edit: {
        title: 'Edit CareerProfileBasicDetails',
      },
      fields: {
        id: 'Id',
        'resume': 'Resume',
        'linkedIn': 'LinkedIn',
        'recentJobTitle': 'Recent Job Title',
        'companyName': 'CompanyName',
        'disciplines': 'Disciplines',
        'yearOfExperienceRange': 'YearOfExperience',
        'yearOfExperience': 'YearOfExperience',
        'jobTitlesInteresedIn': 'Job Titles Interesed In',
        'location': 'Location',
        'latitudeRange': 'Latitude',
        'latitude': 'Latitude',
        'longitudeRange': 'Longitude',
        'longitude': 'Longitude',
        'uSCitizen': 'US Citizen',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {
        'jobTitlesInterestedIn': {
          'composite_technician': 'Composite_technician',
          'composite_engineer': 'Composite_engineer',
          'manufacturing_associate': 'Manufacturing_associate',
          'materials_engineer': 'Materials_engineer',
          'lamination_technician': 'Lamination_technician',
          'composites_part_fabricator': 'Composites_part_fabricator',
          'polymer_composites_scientest': 'Polymer_composites_scientest',
          'manufacturing_technician': 'Manufacturing_technician',
        },
      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New CareerProfileBasicDetails',
      },
      view: {
        title: 'View CareerProfileBasicDetails',
      },
      importer: {
        title: 'Import CareerProfileBasicDetails',
        fileName: 'careerProfileBasicDetails_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    careerProfileExperience: {
      name: 'careerProfileExperience',
      label: 'CareerProfileExperiences',
      menu: 'CareerProfileExperiences',
      exporterFileName: 'careerProfileExperience_export',
      list: {
        menu: 'CareerProfileExperiences',
        title: 'CareerProfileExperiences',
      },
      create: {
        success: 'CareerProfileExperience successfully saved',
      },
      update: {
        success: 'CareerProfileExperience successfully saved',
      },
      destroy: {
        success: 'CareerProfileExperience successfully deleted',
      },
      destroyAll: {
        success: 'CareerProfileExperience(s) successfully deleted',
      },
      edit: {
        title: 'Edit CareerProfileExperience',
      },
      fields: {
        id: 'Id',
        'tools': 'Tools',
        'startDateRange': 'StartDate',
        'startDate': 'StartDate',
        'endDateRange': 'EndDate',
        'endDate': 'EndDate',
        'stillWorking': 'StillWorking',
        'phasesOfDevelopment': 'Phases Of Development',
        'coreSkillsAndTools': 'CoreSkillsAndTools',
        'additionalSkills': 'AdditionalSkills',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {
        'phasesOfDevelopment': {
          'reasearch_concept_development': 'Reasearch_concept_development',
          'product_designer prototyping_and_design_validation': 'Product_designer prototyping_and_design_validation',
          'pre-production_and_automation': 'Pre-production_and_automation',
          'production_support': 'Production_support',
          'quality_assurance': 'Quality_assurance',
        },
      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New CareerProfileExperience',
      },
      view: {
        title: 'View CareerProfileExperience',
      },
      importer: {
        title: 'Import CareerProfileExperiences',
        fileName: 'careerProfileExperience_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    careerProfilePreferences: {
      name: 'careerProfilePreferences',
      label: 'CareerProfilePreferences',
      menu: 'CareerProfilePreferences',
      exporterFileName: 'careerProfilePreferences_export',
      list: {
        menu: 'CareerProfilePreferences',
        title: 'CareerProfilePreferences',
      },
      create: {
        success: 'CareerProfilePreferences successfully saved',
      },
      update: {
        success: 'CareerProfilePreferences successfully saved',
      },
      destroy: {
        success: 'CareerProfilePreferences successfully deleted',
      },
      destroyAll: {
        success: 'CareerProfilePreferences(s) successfully deleted',
      },
      edit: {
        title: 'Edit CareerProfilePreferences',
      },
      fields: {
        id: 'Id',
        'seniorityLevel': 'SeniorityLevel',
        'targetSalaryRange': 'TargetSalary',
        'targetSalary': 'TargetSalary',
        'employmentType': 'EmploymentType',
        'openToContract': 'Open To Contract',
        'preferredCompanySize': 'Preferred Company Size',
        'preferedIndustries': 'PreferedIndustries',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {
        'seniorityLevel': {
          'entry': 'Entry',
          'masters_phd_grad': 'Masters PHD Grad',
          'mid_level': 'Mid level',
          'manager': 'Manager',
          'director': 'Director',
          'executive_or_vp': 'Executive or VP',
        },
        'employmentType': {
          'office': 'Office',
          'hybrid': 'Hybrid',
          'flexible': 'Flexible',
          'remote': 'Remote',
        },
        'preferredCompanySize': {
          'under_50_employees': 'Under 50 employees',
          '50_249_employees': '50-249 employees',
          '250_999_employees': '250-999 employees',
          '1000_5000_employees': '1000-5000 employees',
          '5000_plus_employees': '5000 plus employees',
        },
        'preferedIndustries': {
          'aerospace': 'Aerospace',
          'automotive': 'Automotive',
          'construction': 'Construction',
          'defense': 'Defense',
          'marine': 'Marine',
          'mass_transit': 'Mass Transit',
          'consumer': 'Consumer',
          'energy_wind': 'Energy Wind',
          'energy_storage': 'Energystorage',
          'urban_air_mobility': 'Urban Air mobility',
        },
      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New CareerProfilePreferences',
      },
      view: {
        title: 'View CareerProfilePreferences',
      },
      importer: {
        title: 'Import CareerProfilePreferences',
        fileName: 'careerProfilePreferences_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    careerProfileGeneralProfile: {
      name: 'careerProfileGeneralProfile',
      label: 'CareerProfileGeneralProfiles',
      menu: 'CareerProfileGeneralProfiles',
      exporterFileName: 'careerProfileGeneralProfile_export',
      list: {
        menu: 'CareerProfileGeneralProfiles',
        title: 'CareerProfileGeneralProfiles',
      },
      create: {
        success: 'CareerProfileGeneralProfile successfully saved',
      },
      update: {
        success: 'CareerProfileGeneralProfile successfully saved',
      },
      destroy: {
        success: 'CareerProfileGeneralProfile successfully deleted',
      },
      destroyAll: {
        success: 'CareerProfileGeneralProfile(s) successfully deleted',
      },
      edit: {
        title: 'Edit CareerProfileGeneralProfile',
      },
      fields: {
        id: 'Id',
        'phoneNumber': 'PhoneNumber',
        'profileImage': 'Profile Image',
        'selfDescription': 'SelfDescription',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New CareerProfileGeneralProfile',
      },
      view: {
        title: 'View CareerProfileGeneralProfile',
      },
      importer: {
        title: 'Import CareerProfileGeneralProfiles',
        fileName: 'careerProfileGeneralProfile_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    skillProgress: {
      name: 'skillProgress',
      label: 'SkillProgresses',
      menu: 'SkillProgresses',
      exporterFileName: 'skillProgress_export',
      list: {
        menu: 'SkillProgresses',
        title: 'SkillProgresses',
      },
      create: {
        success: 'SkillProgress successfully saved',
      },
      update: {
        success: 'SkillProgress successfully saved',
      },
      destroy: {
        success: 'SkillProgress successfully deleted',
      },
      destroyAll: {
        success: 'SkillProgress(s) successfully deleted',
      },
      edit: {
        title: 'Edit SkillProgress',
      },
      fields: {
        id: 'Id',
        'currentQuestion': 'CurrentQuestion',
        'completedQuestions': 'CompletedQuestions',
        'skillModel': 'SkillModel',
        'progressRange': 'Progress',
        'progress': 'Progress',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {
        'progress': '{ % value based on   GradePoints / TotalPoints }',
      },
      hints: {

      },
      new: {
        title: 'New SkillProgress',
      },
      view: {
        title: 'View SkillProgress',
      },
      importer: {
        title: 'Import SkillProgresses',
        fileName: 'skillProgress_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    blog: {
      name: 'blog',
      label: 'Blogs',
      menu: 'Blogs',
      exporterFileName: 'blog_export',
      list: {
        menu: 'Blogs',
        title: 'Blogs',
      },
      create: {
        success: 'Blog successfully saved',
      },
      update: {
        success: 'Blog successfully saved',
      },
      destroy: {
        success: 'Blog successfully deleted',
      },
      destroyAll: {
        success: 'Blog(s) successfully deleted',
      },
      edit: {
        title: 'Edit Blog',
      },
      fields: {
        id: 'Id',
        'title': 'Title',
        'thumbnail': 'Thumbnail',
        'markdownContent': 'MarkdownContent',
        'description': 'Description',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Blog',
      },
      view: {
        title: 'View Blog',
      },
      importer: {
        title: 'Import Blogs',
        fileName: 'blog_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    skillAssesmentProgress: {
      name: 'skillAssesmentProgress',
      label: 'SkillAssesmentProgresses',
      menu: 'SkillAssesmentProgresses',
      exporterFileName: 'skillAssesmentProgress_export',
      list: {
        menu: 'SkillAssesmentProgresses',
        title: 'SkillAssesmentProgresses',
      },
      create: {
        success: 'SkillAssesmentProgress successfully saved',
      },
      update: {
        success: 'SkillAssesmentProgress successfully saved',
      },
      destroy: {
        success: 'SkillAssesmentProgress successfully deleted',
      },
      destroyAll: {
        success: 'SkillAssesmentProgress(s) successfully deleted',
      },
      edit: {
        title: 'Edit SkillAssesmentProgress',
      },
      fields: {
        id: 'Id',
        'recentGradeRange': 'Recent Grade',
        'recentGrade': 'Recent Grade',
        'quiz': 'Quiz',
        'gradeHistory': 'GradeHistory',
        'intervalRange': 'Interval',
        'interval': 'Interval',
        'repetitionRange': 'Repetition',
        'repetition': 'Repetition',
        'efactorRange': 'Efactor',
        'efactor': 'Efactor',
        'dueDateRange': 'Due Date',
        'dueDate': 'Due Date',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New SkillAssesmentProgress',
      },
      view: {
        title: 'View SkillAssesmentProgress',
      },
      importer: {
        title: 'Import SkillAssesmentProgresses',
        fileName: 'skillAssesmentProgress_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    skillModel: {
      name: 'skillModel',
      label: 'SkillModels',
      menu: 'SkillModels',
      exporterFileName: 'skillModel_export',
      list: {
        menu: 'SkillModels',
        title: 'SkillModels',
      },
      create: {
        success: 'SkillModel successfully saved',
      },
      update: {
        success: 'SkillModel successfully saved',
      },
      destroy: {
        success: 'SkillModel successfully deleted',
      },
      destroyAll: {
        success: 'SkillModel(s) successfully deleted',
      },
      edit: {
        title: 'Edit SkillModel',
      },
      fields: {
        id: 'Id',
        'questions': 'Questions',
        'totalPointsRange': 'TotalPoints',
        'totalPoints': 'TotalPoints',
        'skill': 'Skill',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New SkillModel',
      },
      view: {
        title: 'View SkillModel',
      },
      importer: {
        title: 'Import SkillModels',
        fileName: 'skillModel_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    tag: {
      name: 'tag',
      label: 'Tags',
      menu: 'Tags',
      exporterFileName: 'tag_export',
      list: {
        menu: 'Tags',
        title: 'Tags',
      },
      create: {
        success: 'Tag successfully saved',
      },
      update: {
        success: 'Tag successfully saved',
      },
      destroy: {
        success: 'Tag successfully deleted',
      },
      destroyAll: {
        success: 'Tag(s) successfully deleted',
      },
      edit: {
        title: 'Edit Tag',
      },
      fields: {
        id: 'Id',
        'name': 'Name',
        'parent': 'Parent',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Tag',
      },
      view: {
        title: 'View Tag',
      },
      importer: {
        title: 'Import Tags',
        fileName: 'tag_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    manual: {
      name: 'manual',
      label: 'Manuals',
      menu: 'Manuals',
      exporterFileName: 'manual_export',
      list: {
        menu: 'Manuals',
        title: 'Manuals',
      },
      create: {
        success: 'Manual successfully saved',
      },
      update: {
        success: 'Manual successfully saved',
      },
      destroy: {
        success: 'Manual successfully deleted',
      },
      destroyAll: {
        success: 'Manual(s) successfully deleted',
      },
      edit: {
        title: 'Edit Manual',
      },
      fields: {
        id: 'Id',
        'title': 'Title',
        'file': 'File',
        'skill': 'Skill',
        'documentThumbnail': 'Thumbnail',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New Manual',
      },
      view: {
        title: 'View Manual',
      },
      importer: {
        title: 'Import Manuals',
        fileName: 'manual_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    threeDModel: {
      name: 'threeDModel',
      label: 'ThreeDModels',
      menu: 'ThreeDModels',
      exporterFileName: 'threeDModel_export',
      list: {
        menu: 'ThreeDModels',
        title: 'ThreeDModels',
      },
      create: {
        success: 'ThreeDModel successfully saved',
      },
      update: {
        success: 'ThreeDModel successfully saved',
      },
      destroy: {
        success: 'ThreeDModel successfully deleted',
      },
      destroyAll: {
        success: 'ThreeDModel(s) successfully deleted',
      },
      edit: {
        title: 'Edit ThreeDModel',
      },
      fields: {
        id: 'Id',
        'name': 'Name',
        'aIDescription': 'Description',
        'file': 'File',
        'skill': 'Skill',
        'embed': 'Embed',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New ThreeDModel',
      },
      view: {
        title: 'View ThreeDModel',
      },
      importer: {
        title: 'Import ThreeDModels',
        fileName: 'threeDModel_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },

    displaySettings: {
      name: 'displaySettings',
      label: 'DisplaySettings',
      menu: 'DisplaySettings',
      exporterFileName: 'displaySettings_export',
      list: {
        menu: 'DisplaySettings',
        title: 'DisplaySettings',
      },
      create: {
        success: 'DisplaySettings successfully saved',
      },
      update: {
        success: 'DisplaySettings successfully saved',
      },
      destroy: {
        success: 'DisplaySettings successfully deleted',
      },
      destroyAll: {
        success: 'DisplaySettings(s) successfully deleted',
      },
      edit: {
        title: 'Edit DisplaySettings',
      },
      fields: {
        id: 'Id',
        'name': 'Name',
        'manualThumbnail': 'ManualThumbnail',
        'companyTitleImage': 'companyTitleImage',
        'customPrimaryColor': 'CustomPrimaryColor',
        'customSecondaryColor': 'CustomSecondaryColor',
        'company': 'Company',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New DisplaySettings',
      },
      view: {
        title: 'View DisplaySettings',
      },
      importer: {
        title: 'Import DisplaySettings',
        fileName: 'displaySettings_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
    workspaceSettings: {
      name: 'workspaceSettings',
      label: 'WorkspaceSettings',
      menu: 'WorkspaceSettings',
      exporterFileName: 'workspaceSettings_export',
      list: {
        menu: 'WorkspaceSettings',
        title: 'WorkspaceSettings',
      },
      create: {
        success: 'WorkspaceSettings successfully saved',
      },
      update: {
        success: 'WorkspaceSettings successfully saved',
      },
      destroy: {
        success: 'WorkspaceSettings successfully deleted',
      },
      destroyAll: {
        success: 'WorkspaceSettings(s) successfully deleted',
      },
      edit: {
        title: 'Edit WorkspaceSettings',
      },
      fields: {
        id: 'Id',
        'logo': 'Logo',
        'emailDomain': 'Email Domain',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        createdAtRange: 'Created at',
      },
      enumerators: {

      },
      placeholders: {

      },
      hints: {

      },
      new: {
        title: 'New WorkspaceSettings',
      },
      view: {
        title: 'View WorkspaceSettings',
      },
      importer: {
        title: 'Import WorkspaceSettings',
        fileName: 'workspaceSettings_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space.',
      },
    },
  },



  auth: {
    tenants: 'Workspaces',
    profile: {
      title: 'Profile',
      success: 'Profile successfully updated',
    },
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password',
    signin: 'Sign in',
    signup: 'Sign up',
    signout: 'Sign out',
    alreadyHaveAnAccount:
      'Already have an account? Sign in.',
    createAnAccount: `Don't have an account? Create one.`,
    social: {
      header: 'or sign in with Social Media',
      signinWithGoogle: 'Sign in with Google',
      errors: {
        'auth-invalid-provider':
          'This email is already registered to another provider.',
        'auth-no-email': `The email associated with this account is private or inexistent.`,
      },
    },
    signinWithAnotherAccount:
      'Sign in with another account',
    emailUnverified: {
      message: `Please confirm your email at <strong>{0}</strong> to continue.`,
      submit: `Resend email verification`,
    },
    emptyPermissions: {
      message: `You have no permissions yet. Wait for the admin to grant you privileges.`,
    },
    passwordResetEmail: {
      message: 'Send password reset email',
      error: `Email not recognized`,
    },
    passwordReset: {
      message: 'Reset password',
    },
    passwordChange: {
      title: 'Change Password',
      success: 'Password successfully changed',
      mustMatch: 'Passwords must match',
    },
    emailAddressVerificationEmail: {
      error: `Email not recognized`,
    },
    verificationEmailSuccess: `Verification email successfully sent`,
    passwordResetEmailSuccess: `Password reset email successfully sent`,
    passwordResetSuccess: `Password successfully changed`,
    verifyEmail: {
      success: 'Email successfully verified.',
      message:
        'Just a moment, your email is being verified...',
    },
  },

  roles: {
    admin: {
      label: 'Admin',
      description: 'Full access to all resources',
    },
    custom: {
      label: 'User',
      description: 'User role access',
    },
    instructor: {
      label: "Instructor",
      description: "Instructor role access",
    }
  },

  user: {
    fields: {
      id: 'Id',
      avatars: 'Avatar',
      email: 'Email',
      emails: 'Email(s)',
      fullName: 'Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      status: 'Status',
      phoneNumber: 'Phone Number',
      role: 'Role',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
      roleUser: 'Role/User',
      roles: 'Roles',
      createdAtRange: 'Created at',
      password: 'Password',
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      newPasswordConfirmation: 'New Password Confirmation',
      rememberMe: 'Remember me',
      location: 'Location',
      org: 'Major Command',
      occupation: 'Occupation',
    },
    status: {
      active: 'Active',
      invited: 'Invited',
      'empty-permissions': 'Waiting for Permissions',
    },
    invite: 'Invite',
    validations: {
      // eslint-disable-next-line
      email: 'Email ${value} is invalid',
    },
    title: 'Users',
    menu: 'Users',
    doAddSuccess: 'User(s) successfully saved',
    doUpdateSuccess: 'User successfully saved',
    exporterFileName: 'users_export',
    doDestroySuccess: 'User successfully deleted',
    doDestroyAllSelectedSuccess:
      'Users successfully deleted',
    edit: {
      title: 'Edit User',
    },
    new: {
      title: 'Invite User(s)',
      titleModal: 'Invite User',
      emailsHint:
        'Separate multiple email addresses using the comma character.',
    },
    view: {
      title: 'User',
      activity: 'Activity',
    },
    importer: {
      title: 'Import Users',
      fileName: 'users_import_template',
      hint:
        'Files/Images columns must be the URLs of the files separated by space. Relationships must be the ID of the referenced records separated by space. Roles must be the role ids separated by space.',
    },
    errors: {
      userAlreadyExists:
        'User with this email already exists',
      userNotFound: 'User not found',
      revokingOwnPermission: `You can't revoke your own admin permission`,
    },
  },

  tenant: {
    name: 'tenant',
    label: 'Workspaces',
    menu: 'Workspaces',
    list: {
      menu: 'Workspaces',
      title: 'Workspaces',
    },
    create: {
      button: 'Create Workspace',
      success: 'Workspace successfully saved',
    },
    update: {
      success: 'Workspace successfully saved',
    },
    destroy: {
      success: 'Workspace successfully deleted',
    },
    destroyAll: {
      success: 'Workspace(s) successfully deleted',
    },
    edit: {
      title: 'Edit Workspace',
    },
    fields: {
      id: 'Id',
      name: 'Name',
      url: 'URL',
      tenantName: 'Workspace Name',
      tenantId: 'Workspace',
      tenantUrl: 'Workspace URL',
      plan: 'Plan',
    },
    enumerators: {},
    new: {
      title: 'New Workspace',
    },
    invitation: {
      view: 'Invitations',
      invited: 'Invited',
      accept: 'Accept Invitation',
      decline: 'Decline Invitation',
      declined: 'Invitation successfully declined',
      acceptWrongEmail: 'Accept Invitation With This Email',
    },
    select: 'Select Workspace',
    validation: {
      url:
        'Your workspace URL can only contain lowercase letters, numbers and dashes (and must start with a letter or number).',
    },
  },

  plan: {
    menu: 'Plans',
    title: 'Plans',

    free: {
      label: 'Free',
      price: '$0',
    },
    growth: {
      label: 'Growth',
      price: '$25',
    },
    enterprise: {
      label: 'Enterprise',
      price: '$30',
    },

    pricingPeriod: '/month',
    current: 'Current Plan',
    subscribe: 'Subscribe',
    manage: 'Manage Subscription',
    cancelAtPeriodEnd:
      'This plan will be canceled at the end of the period.',
    somethingWrong:
      'There is something wrong with your subscription. Please go to manage subscription for more details.',
    notPlanUser: `You are not the manager of this subscription.`,
  },

  auditLog: {
    menu: 'Audit Logs',
    title: 'Audit Logs',
    exporterFileName: 'audit_log_export',
    entityNamesHint:
      'Separate multiple entities using the comma character.',
    fields: {
      id: 'Id',
      timestampRange: 'Period',
      entityName: 'Entity',
      entityNames: 'Entities',
      entityId: 'Entity ID',
      action: 'Action',
      values: 'Values',
      timestamp: 'Date',
      createdByEmail: 'User Email',
    },
  },
  settings: {
    title: 'Settings',
    menu: 'Settings',
    save: {
      success:
        'Settings successfully saved. The page will reload in {0} seconds for changes to take effect.',
    },
    fields: {
      theme: 'Theme',
      logos: 'Logo',
      backgroundImages: 'Background Image',
    },
    colors: {
      default: 'Dark',
      light: 'Light',
      cyan: 'Cyan',
      'geek-blue': 'Geek Blue',
      gold: 'Gold',
      lime: 'Lime',
      magenta: 'Magenta',
      orange: 'Orange',
      'polar-green': 'Polar Green',
      purple: 'Purple',
      red: 'Red',
      volcano: 'Volcano',
      yellow: 'Yellow',
    },
  },
  dashboard: {
    menu: 'Dashboard',
    message: `This page uses fake data for demonstration purposes only. You can edit it at frontend/view/dashboard/DashboardPage.ts.`,
    charts: {
      day: 'Day',
      red: 'Red',
      green: 'Green',
      yellow: 'Yellow',
      grey: 'Grey',
      blue: 'Blue',
      orange: 'Orange',
      months: {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
      },
      eating: 'Eating',
      drinking: 'Drinking',
      sleeping: 'Sleeping',
      designing: 'Designing',
      coding: 'Coding',
      cycling: 'Cycling',
      running: 'Running',
      customer: 'Customer',
    },
  },
  errors: {
    backToHome: 'Back to home',
    403: `Sorry, you don't have access to this page`,
    404: 'Sorry, the page you visited does not exist',
    500: 'Sorry, the server is reporting an error',
    429: 'Too many requests. Please try again later.',
    forbidden: {
      message: 'Forbidden',
    },
    validation: {
      message: 'An error occurred',
    },
    defaultErrorMessage: 'Ops, an error occurred',
  },

  preview: {
    error:
      'Sorry, this operation is not allowed in preview mode.',
  },

  // See https://github.com/jquense/yup#using-a-custom-locale-dictionary
  /* eslint-disable */
  validation: {
    mixed: {
      default: '${path} is invalid',
      required: '${path} is required',
      oneOf:
        '${path} must be one of the following values: ${values}',
      notOneOf:
        '${path} must not be one of the following values: ${values}',
      notType: ({ path, type, value, originalValue }) => {
        return `${path} must be a ${type}`;
      },
    },
    string: {
      length:
        '${path} must be exactly ${length} characters',
      min: '${path} must be at least ${min} characters',
      max: '${path} must be at most ${max} characters',
      matches:
        '${path} must match the following: "${regex}"',
      email: '${path} must be a valid email',
      url: '${path} must be a valid URL',
      trim: '${path} must be a trimmed string',
      lowercase: '${path} must be a lowercase string',
      uppercase: '${path} must be a upper case string',
      selected: '${path} must be selected',
    },
    number: {
      min:
        '${path} must be greater than or equal to ${min}',
      max: '${path} must be less than or equal to ${max}',
      lessThan: '${path} must be less than ${less}',
      moreThan: '${path} must be greater than ${more}',
      notEqual: '${path} must be not equal to ${notEqual}',
      positive: '${path} must be a positive number',
      negative: '${path} must be a negative number',
      integer: '${path} must be an integer',
    },
    date: {
      min: '${path} field must be later than ${min}',
      max: '${path} field must be at earlier than ${max}',
    },
    boolean: {},
    object: {
      noUnknown:
        '${path} field cannot have keys not specified in the object shape',
    },
    array: {
      min: ({ min, path }) =>
        min === 1
          ? `${path} is required`
          : `${path} field must have at least ${min} items`,
      max:
        '${path} field must have less than or equal to ${max} items',
    },
  },
  /* eslint-disable */
  fileUploader: {
    upload: 'Upload',
    image: 'You must upload an image',
    size: 'File is too big. Max allowed size is {0}',
    formats: `Invalid format. Must be one of: {0}.`,
  },
  importer: {
    line: 'Line',
    status: 'Status',
    pending: 'Pending',
    imported: 'Imported',
    error: 'Error',
    total: `{0} imported, {1} pending and {2} with error`,
    importedMessage: `Processed {0} of {1}.`,
    noNavigateAwayMessage:
      'Do not navigate away from this page or import will be stopped.',
    completed: {
      success:
        'Import completed. All rows were successfully imported.',
      someErrors:
        'Processing completed, but some rows were unable to be imported.',
      allErrors: 'Import failed. There are no valid rows.',
    },
    form: {
      downloadTemplate: 'Download the template',
      hint:
        'Click or drag the file to this area to continue',
    },
    list: {
      discardConfirm:
        'Are you sure? Non-imported data will be lost.',
    },
    errors: {
      invalidFileEmpty: 'The file is empty',
      invalidFileExcel:
        'Only excel (.xlsx) files are allowed',
      invalidFileUpload:
        'Invalid file. Make sure you are using the last version of the template.',
      importHashRequired: 'Import hash is required',
      importHashExistent: 'Data has already been imported',
    },
  },

  autocomplete: {
    loading: 'Loading...',
    noOptions: 'No data found',
  },

  imagesViewer: {
    noImage: 'No image',
  },

  table: {
    noData: 'No records found',
    loading: 'Loading...',
  },

  pagination: {
    items_per_page: '/ page',
    jump_to: 'Goto',
    jump_to_confirm: 'confirm',
    page: '',

    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
  },
};

export default en;
